import { textAnimations } from './utils/text-animations';
import { initMediasEvents } from './utils/medias';

export default function () {
    // -------------------------------------
    // Texts animations
    // -------------------------------------
    textAnimations();

    // -------------------------------------
    // Media events (toggle play/pause)
    // -------------------------------------
    initMediasEvents();
}
